module.exports = __webpack_public_path__ + "static/media/lowra.cc9f8217.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/lowra.jpeg
// module id = 284
// module chunks = 0